export default "__VITE_ASSET__uGNqC_Lz__"